import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { PumpAlgorithmState } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  PumpAlgorithmDisconnectedIcon,
  PumpAlgorithmInactiveIcon,
  PumpAlgorithmRaisedIcon,
  PumpAlgorithmReducedIcon,
  PumpAlgorithmSuspendedIcon,
} from "@tandemdiabetes/sugarmate-react-components"

import type {
  ComponentPropsWithoutRef,
  FC,
  Ref,
  SVGProps,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { getPumpAlgorithmState } from "./getPumpAlgorithmState"

import type { DataRecency } from "src/types"

export interface Props extends ComponentPropsWithoutRef<"svg"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpAlgorithmIcon = forwardRef<SVGElement, Props>(
  function PumpAlgorithmIcon(props: Props, propRef: Ref<SVGElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...svgProps
    } = props

    const algorithmState = getPumpAlgorithmState(
      pumpStatus,
      pumpStatusRecency,
    )

    const Icon: FC<SVGProps<SVGElement>> = useMemo(
      () => {
        switch (algorithmState) {
          case PumpAlgorithmState.NotAvailable:
            return PumpAlgorithmDisconnectedIcon
          case PumpAlgorithmState.Suspended:
            return PumpAlgorithmSuspendedIcon
          case PumpAlgorithmState.Reduced:
            return PumpAlgorithmReducedIcon
          case PumpAlgorithmState.Raised:
            return PumpAlgorithmRaisedIcon
          case PumpAlgorithmState.NoData:
          case PumpAlgorithmState.Off:
          case PumpAlgorithmState.Inactive:
          default:
            return PumpAlgorithmInactiveIcon
        }
      },
      [algorithmState],
    )

    return (
      <Icon
        {...svgProps}
        ref={propRef}
      />
    )
  },
)
